import React, { ReactElement, useEffect, useState } from 'react';
import { Table, Typography } from 'antd';
import { Key } from 'antd/lib/table/interface';

import { useBreederAdminsContext } from 'dogpark/context';
import { testId } from 'dogpark/utilities/test/datatestId';
import BreederAdminsExpandableRowContent from './breederAdminsExpandableRowContent/BreederAdminsExpandableRowContent';

import { BreederAdminsTableStyled } from './BreederAdminsTable.styles';

const { Text } = Typography;

function BreederAdminsTable(): ReactElement {
  const [activeExpRowKeys, setActiveExpRowKeys] = useState<Key[]>([]);
  const {
    state: { loading, breederAdmins },
  } = useBreederAdminsContext();

  useEffect(() => {
    loading && setActiveExpRowKeys([]);
  }, [loading]);

  return (
    <BreederAdminsTableStyled>
      <Table
        data-testid={testId.breederAdminsTable}
        className="breeder-admins-table"
        loading={loading}
        dataSource={breederAdmins}
        rowKey={(record) => record.id}
        columns={[
          {
            title: 'ID',
            dataIndex: 'breeders',
            width: '135px',
            render: (breeders) => breeders[0].id,
          },
          {
            title: 'First',
            dataIndex: 'firstName',
          },
          {
            title: 'Last',
            dataIndex: 'lastName',
          },
          {
            title: 'Email',
            dataIndex: 'email',
          },
          {
            title: 'Status',
            dataIndex: 'isActive',
            render: (isActive) => (
              <Text type={isActive ? 'success' : 'secondary'}>
                {isActive ? 'Active' : 'Inactive'}
              </Text>
            ),
          },
        ]}
        expandable={{
          expandedRowKeys: activeExpRowKeys,
          onExpand: (expanded, record) => {
            setActiveExpRowKeys((state) =>
              expanded ? [...state, record.id] : state.filter((key) => key !== record.id),
            );
          },
          expandedRowRender: (record) => (
            <BreederAdminsExpandableRowContent breederAdmin={record} />
          ),
        }}
        scroll={{ x: true }}
        pagination={{
          hideOnSinglePage: true,
          pageSize: 100,
        }}
      />
    </BreederAdminsTableStyled>
  );
}

export default BreederAdminsTable;
